export const activityOverTimeSwitcher = [
  {
    key: 'days',
    value: 'daily',
    disabled: false,
  },
  {
    key: 'months',
    value: 'monthly',
    disabled: false,
  },
]
